/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Kirtan's Portfolio",
  description:
    "I'm a CS undergrad, proficient in Neural Networks, AI-ML, Python, and Full Stack Web development. I am excited to keep pushing boundaries and make meaningful contributions to the tech industry.",
  og: {
    title: "Kirtan Ghelani Portfolio",
    type: "website",
    url: "",
  },
};

// "I'm a CS undergrad, proficient in Neural Networks, AI-ML, Python, and Full Stack Web development. I am excited to keep pushing boundaries and make meaningful contributions to the tech industry.",
//Home Page
const greeting = {
  title: "Kirtan Ghelani",
  logo_name: "GhelaniKirtan",
  subTitle:
    "AI/ML engineer who builds deep learning and agentic AI systems end-to-end, from data and training through production-grade inference. Equally at home across the full web stack, from React to Python backends.",
  // resumeLink: "",
  resumeLink: require("./assests/files/Resume.pdf"),
  portfolio_repository: "https://github.com/ghelanikirtan",
  githubProfile: "https://github.com/ghelanikirtan",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  {
    name: "Github",
    link: "https://github.com/ghelanikirtan",
    fontAwesomeIcon: "fa-github ", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#1a1a1b", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/kirtan-ghelani/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:kghelani.dev@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "X-Twitter",
    link: "https://x.com/kirtan_ghelani",
    fontAwesomeIcon: "fa-x-twitter", // Reference https://fontawesome.com/icons/x-twitter?f=brands&s=solid
    backgroundColor: "#1a1a1b", // Reference https://simpleicons.org/?q=x
  },
  // {
  //   name: "Instagram",
  //   link: "https://www.instagram.com/k_ghelani02/",
  //   fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
  //   backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  // },
];

const skills = {
  data: [
    {
      title: "Artificial Intelligence & Data Science",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Builds computer vision and deep learning systems end-to-end, from PyTorch model training to ONNX/CUDA-optimized real-time inference.",
        "⚡ Designs agentic AI and LLM-powered systems with LangGraph, LangChain, and the HuggingFace ecosystem, using RAG pipelines for grounded outputs.",
        "⚡ Tracks experiments with MLflow and builds data pipelines with NumPy and Pandas.",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          // fontAwesomeClassname: "logos-pytorch",
          fontAwesomeClassname: "simple-icons:pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
        {
          skillName: "LangChain",
          fontAwesomeClassname: "simple-icons:langchain",
          style: {
            color: "#7FC8FF",
          },
        },
        {
          skillName: "LangGraph",
          fontAwesomeClassname: "simple-icons:langgraph",
          style: {
            color: "#7FC8FF",
          },
        },
        {
          skillName: "HuggingFace",
          fontAwesomeClassname: "simple-icons:huggingface",
          style: {
            color: "#FFD21E",
          },
        },
        {
          skillName: "ONNX",
          fontAwesomeClassname: "simple-icons:onnx",
          style: {
            color: "#005CED",
          },
        },
        {
          skillName: "MLflow",
          fontAwesomeClassname: "simple-icons:mlflow",
          style: {
            color: "#0194E2",
          },
        },
        {
          skillName: "NumPy",
          fontAwesomeClassname: "logos:numpy",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "logos:pandas",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Qdrant",
          fontAwesomeClassname: "simple-icons:qdrant",
          style: {
            color: "#DC244C",
          },
        },
        {
          skillName: "CUDA",
          fontAwesomeClassname: "simple-icons:nvidia",
          style: {
            color: "#76B900",
          },
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Builds and ships production backend services with FastAPI and Node/Express, backed by PostgreSQL, Redis, and vector databases like Qdrant.",
        "⚡ Deploys and operates systems on AWS and GCP using Docker, infrastructure-as-code, and CI/CD pipelines with GitHub Actions.",
        "⚡ Equally comfortable building complete end-to-end products with React and Next.js.",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "TailwindCSS",
          fontAwesomeClassname: "simple-icons:tailwindcss",
          style: {
            color: "#38BDF8",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            // backgroundColor: "#fff",
            color: "#3178C6",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NextJS",
          fontAwesomeClassname: "simple-icons:nextdotjs",
          style: {
            color: "#FFF",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Express",
          fontAwesomeClassname: "simple-icons:express",
          style: {
            color: "#FFF",
          },
        },
        // {
        //   skillName: "NPM",
        //   fontAwesomeClassname: "simple-icons:npm",
        //   style: {
        //     color: "#CB3837",
        //   },
        // },
        {
          skillName: "SQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "FastAPI",
          fontAwesomeClassname: "simple-icons:fastapi",
          style: {
            color: "#009688",
          },
        },
        {
          skillName: "Pydantic",
          fontAwesomeClassname: "simple-icons:pydantic",
          style: {
            color: "#E92063",
          },
        },
        {
          skillName: "Redis",
          fontAwesomeClassname: "simple-icons:redis",
          style: {
            color: "#FF4438",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#2496ED",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "logos:aws",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: {
            color: "#2088FF",
          },
        },
        {
          skillName: "Pulumi",
          fontAwesomeClassname: "simple-icons:pulumi",
          style: {
            color: "#8A3391",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/kyghelani",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/kirtanghelani",
    },
    {
      siteName: "Medium",
      iconifyClassname: "simple-icons:medium",
      style: {
        color: "#000",
      },
      profileLink: "https://medium.com/@kyghelani2",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "SRM Institute of Science & Technology",
      subtitle: "B.Tech. in Computer Science & Engineering",
      logo_path: "srm_logo.png",
      alt_name: "SRMIST",
      duration: "2020 - 2024",
      descriptions: [
        "⚡ CGPA: 9.34 / 10.0",
        "⚡ I have studied basic computer science & software engineering subjects like DS, Algorithms, DBMS, OS, COA, AI etc.",
        "⚡ Apart from this, I have done courses on Deep Learning, Data Science, and Full Stack Development.",
      ],
      website_link: "https://srmrmp.edu.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Google Kick Start 2021",
      subtitle: "- Coding Competitions",
      logo_path: "kickstart_logo.jpeg",
      certificate_link:
        "https://drive.google.com/file/d/1WlD6Mp7fXsEKE3SqGuUy0Wn8t6y8dujI/view?usp=sharing",
      alt_name: "kickstart21",
      color_code: "#FFFFFF",
    },
    {
      title: "AI Classroom Series 2020",
      subtitle: "- Microsoft",
      logo_path: "microsoft.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1GyyLJJTR1a5ibmn5-r5n1PyNzJhXIUhV/view?usp=sharing",
      alt_name: "microsoftAISeries",
      color_code: "#FFFFFF",
    },
    {
      title: "Python for Data Science & Machine Learning Bootcamp",
      subtitle: "- Jose Portilla (Udemy)",
      logo_path: "udemy_logo.jpg",
      certificate_link:
        "https://www.udemy.com/certificate/UC-0e090522-5359-4635-b35d-91a3397c09c4/",
      alt_name: "udemy_python_DSML",
      color_code: "#FFFFFF",
    },
    {
      title: "Coders Cave Internship Program",
      subtitle: "- Coders Cave",
      logo_path: "coderscave.png",
      certificate_link:
        "https://certificate.givemycertificate.com/c/2aa27cd0-759f-4ac8-aa89-85827d89d577",
      alt_name: "DS",
      color_code: "#FFFFFF",
    },
    {
      title: "Project Day 2023",
      subtitle: "- SRM IST",
      logo_path: "srm_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1VsToESZH9Lhpc8QRZ9L_1wQuJSlPMYpS/view?usp=sharing",
      alt_name: "SRMRMP",
      color_code: "#0C477F",
    },
    {
      title: "Generative AI Hackathon Final round Participation (2023)",
      subtitle: "- HACKRX 4.0 by Bajaj Finserv",
      logo_path: "bajaj_finserv.png",
      certificate_link:
        "https://drive.google.com/file/d/1rT9MKQ4ydYF0PwkpbSrMDdAYiQoCsBJD/view?usp=sharing",
      alt_name: "BAJAJFIN",
      color_code: "#0072BC",
    },
    {
      title: "JavaScript Training 2021",
      subtitle: "- SRM AXIS INTELLECTS",
      logo_path: "srm_axis_logo.jpeg",
      certificate_link:
        "https://drive.google.com/file/d/1CO6ufWaT0BJS_WSbFnpQ4UiAGSalRXcg/view?usp=sharing",
      alt_name: "SRMAXIS",
      color_code: "#FFFFFF",
    },
    {
      title: "Comman Line Course Completion",
      subtitle: "- Progate",
      logo_path: "progate.png",
      certificate_link: "https://progate.com/course_certificate/f0bfaa4bqlowet",
      alt_name: "PROGATE",
      color_code: "#FFFFFF",
    },
    {
      title: "GIT (version control) Course Completion",
      subtitle: "- Progate",
      logo_path: "progate.png",
      certificate_link: "https://progate.com/course_certificate/ca65646aqloz7t",
      alt_name: "PROGATE",
      color_code: "#FFFFFF",
    },
    {
      title: "HTML & CSS Course Completion",
      subtitle: "- Progate",
      logo_path: "progate.png",
      certificate_link: "https://progate.com/course_certificate/4db2d8faql97f3",
      alt_name: "PROGATE",
      color_code: "#FFFFFF",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Experience, Internships, Projects and Position of Responsibility",
  description:
    "I'm an AI/ML Engineer at Sculptsoft, building production computer vision and agentic AI systems. Before that, I made more than 20 projects on machine learning, AI and web development, which can be found on my github account. I also completed a data science internship program where I was asked to build 4 projects using data science and AI, and was appointed technical team lead and president of TechWiz, a technical student community at my university.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Experience",
      work: true,
      experiences: [
        {
          title: "AI/ML Engineer",
          company: "Sculptsoft",
          company_url: "https://www.sculptsoft.com/",
          logo_path: "sculptsoft_logo.svg",
          duration: "August 2025 - Present",
          location: "Ahmedabad, India",
          description: [
            "⚡ Building the consumer pipeline for a production inference service (BiRefNet, CLIP ViT-L/14), resolving VRAM and CUDA memory issues that blocked batch processing at millions of records, backed by a hybrid GPU plus KEDA-scaled CPU-overflow architecture.",
            "⚡ Built a multi-agent AI sales automation system (LangGraph, LangChain) covering requirement gathering, stock checks, and quotation generation across a complex, fast-changing catalog, deployed on WhatsApp, Facebook, and Instagram, and live in production for roughly 250 real-time inquiries a day.",
            "⚡ Instrumented LangSmith observability for pipeline debugging and failure tracking, and integrated with the CRM to auto-hand off a conversation to a human rep whenever it drifts off track.",
            "⚡ Delivered a natural-language-to-SQL proof of concept over a production database in a single day, using OpenAI's SDK with an open-source PostgreSQL MCP server, hosted on EC2 for a live demo.",
          ],
          color: "#285EA3",
        },
      ],
    },
    {
      title: "Internships",
      work: true,
      experiences: [
        {
          title: "AIML Intern",
          company: "Sculptsoft",
          company_url: "https://www.sculptsoft.com/",
          logo_path: "sculptsoft_logo.svg",
          duration: "May 2025 - August 2025",
          location: "Ahmedabad, India",
          description:
            "Joined Sculptsoft as an AIML Developer, working on production computer vision and inference pipelines, before converting to a full-time AI/ML Engineer role in August 2025.",
          color: "#285EA3",
        },
        {
          title: "Data Science Intern",
          company: "Coder's Cave",
          company_url:
            "https://certificate.givemycertificate.com/c/2aa27cd0-759f-4ac8-aa89-85827d89d577",
          logo_path: "coderscave_white.png",
          duration: "Sept 2023 - Oct 2023",
          location: "Remote",
          description:
            "Performed exploratory data analysis on a global terrorism dataset and breast cancer classification using Artificial Neural Networks to achieve higher accuracy. Applied random forest classification for email spam classification and neural networks for speech emotion recognition model.",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Projects",
      experiences: [
        // {
        //   title: "AI-Agents",
        //   company: "coming soon! ⭐",
        //   company_url: "https://github.com/ghelanikirtan/AI-Agents",
        //   logo_path: "ai-agents.png",
        //   // duration: "January 2025 - ??",
        //   description:
        //     "Stay tuned! Building an End-to-End application that leverages the use of multiple AI agents.",
        // },
        {
          title: "StylCheck - Visual Testing at Scale",
          company: "Project Link",
          company_url:
            "https://github.com/ghelanikirtan/HackRx-4.0-Code_Blasters",
          logo_path: "stylcheck.png",
          // duration: "July 2023",
          description:
            "Built at HackRx 4.0 by Bajaj Finserv (Generative AI Hackathon). User Interface Design [Figma – Web & Mobile Application Design] testing and scaling using AI and Automation. Used Flask server as a backend to deploy our own trained AI model, and React and Streamlit as Frontend. Subsequently, developed a web browser extension.",
        },
        {
          title: "THERA-BOT",
          company: "Project Link",
          company_url: "https://github.com/ghelanikirtan/THERA-BOT-v.0.0.1",
          logo_path: "therabot.png",
          // duration: "April 2023 - May 2023",
          description:
            "Developed a Personalised chatbot system to provide mental health assistance to a certain level. Used Node server to deploy a LLM, fine-tuned with personalized datasets, and React application as frontend.",
        },
        {
          title: "VoteFlicks",
          company: "Project Link",
          company_url: "https://devfolio.co/projects/voteflicks-9691",
          logo_path: "voteflicks.png",
          // duration: "May 2023",
          description:
            "Built at HackSRM 4.0 and won 'Best in Blockchain' title. Used Solidity, Ethers, and React.js. Automated vote counting through smart contracts for an efficient voting process.",
        },
        {
          title: "ChainDrive",
          company: "Project Link",
          company_url: "https://devfolio.co/projects/chain-drive-d91f",
          logo_path: "chaindrive.png",
          // duration: "April 2023",
          description:
            "Built decentralized storage DApp using IPFS, Solidity, and React.js, and deployed on Polygon via Spheron.",
        },
      ],
    },

    {
      title: "Position of Responsibility",
      experiences: [
        {
          title: "President",
          company: "TechWiz",
          company_url: "https://www.linkedin.com/company/techwiz-srmrmp/",
          logo_path: "techwiz.jpeg",
          duration: "May 2023 - December 2023",
          location: "Chennai, India",
          description:
            "Upon appointment as Techwiz's President, I was successful in conduting events, workshops, and competitions around new trends in tech like Artificial Intelligence, Blockchain, and so on.",
          color: "#4285F4",
        },
        {
          title: "Technical Team Lead",
          company: "TechWiz",
          company_url: "https://www.linkedin.com/company/techwiz-srmrmp/",
          logo_path: "techwiz.jpeg",
          duration: "October 2023 - April 2023",
          location: "Chennai, India",
          description:
            "Led the team to conduct technical workshop on version control (git), and web development providing hands-on experience to the participants. Subsequently, hosted Pair-a-thon (mini hackathon) at Inter-level college fest",
          color: "#D83B01",
        },
        {
          title: "Public Relations Head",
          company: "Campus Life",
          company_url: "https://www.instagram.com/srmrcampuslife.fet/",
          logo_path: "campus_life.png",
          duration: "April 2023 - December 2023",
          location: "Chennai, India",
          description:
            "Campus Life is the only club on SRMIST responsible for conducting cultural events in the university. I Led social media marketing campaigns for inter-level and intra-level college fests.",
          color: "#D83B01",
        },
        {
          title: "Technical Member, Content Writer",
          company: "Google Developer Students Clubs",
          company_url: "https://www.linkedin.com/company/dsc-srm-ramapuram/",
          logo_path: "gdsc.jpeg",
          duration: "April 2021 - April 2022",
          location: "Chennai, India",
          description:
            "We have well established developer club in college which is directly associated with Google Developers. Here I took sessions on ASJ (Android Study Jams) 102 with 100+ participants, and contributed to mini tech blogs and related content during my tenure.",
          color: "#000000",
        },
        {
          title: "Community Lead",
          company: "Codecreek",
          company_url:
            "https://www.linkedin.com/company/codecreek-official/about/",
          logo_path: "codecreek.jpeg",
          duration: "June 2021 - December 2022",
          location: "Remote",
          description:
            "Formed a Cross-college community along with 6 more volunteers. Shared technical knowledge via Google Meet, educating 25+ classmates about Git/GitHub and programming concepts in C++.",
          color: "#0C9D58",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Research Work",
  description: "Some of my research work.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "bladder-tissue-classification",
      name:
        "Bladder Tissue Classification in Multi-Domain Endoscopic Images Using Deep Learning",
      createdAt: "2024-05-06T00:00:00Z",
      description:
        "Paper Submitted to IEEE International Conference on Intelligent Systems and Advance Applications",
      url:
        "https://drive.google.com/file/d/1RB13iX-oSYecTMmR6MqNqSCs6FEf9gjK/view",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "my_dp.png",
    description:
      "I am actively looking for an opportunity to work in the field of Computer Science, Software Development & AI-Driven projects, if you wish to work together on a project, please feel free to reach out! I can help you with AI, Deep Learning, Flask, Django, React.js and Next.js.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I like to document some of my experiences in professional career journey as well as some technical knowledge sharing.",
    link: "https://blogs.ashutoshhathidara.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Gujarat, IN - 362001",
    // locality: "",
    country: "IN",
    region: "Gujarat",
    postalCode: "362001",
    // streetAddress: "",
    // avatar_image_path: "",
    // location_map_link: "https://maps.app.goo.gl/NvYZqa34Wye4tpS17",
  },
  phoneSection: {
    title: "Contact",
    subtitle: "+91 8000823654",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
